import * as React from 'react';
import '../css/accordion.sass';
import '../css/campfire.sass';
import Hat, { HatType } from './Hat';

interface AccordionProps {
  title: React.ReactNode;
  id: string;
  expanded?: boolean;
  children: React.ReactNode;
  onExpand?: Function;
  hat?: HatType[];
  lazyLoad?: boolean;
  theme?: 'day' | 'night';
  flipBg?: boolean;
  isDivider?: boolean;
}

interface AccordionState {
  expanded: boolean;
}

export default function Accordion(props: AccordionProps) {
  const { theme = 'day' } = props;
  const { lazyLoad = false } = props;
  let recursiveCount = 0;
  const getInnerText = (obj: any) => {
    recursiveCount += 1;
    let buf = '';
    if (obj) {
      const type = typeof obj;
      if (type === 'string' || type === 'number') {
        buf += obj;
      } else if (type === 'object') {
        let objchildren = null;
        if (Array.isArray(obj)) {
          objchildren = obj;
        } else {
          const objprops = obj.props;
          if (objprops) {
            objchildren = objprops.children;
          }
        }
        if (objchildren && recursiveCount < 5) {
          if (Array.isArray(objchildren)) {
            objchildren.forEach(function(o) {
              buf += getInnerText(o);
            });
          } else {
            buf += getInnerText(objchildren);
          }
        }
      }
    }
    return buf;
  };

  const [state, setState] = React.useState<AccordionState>({
    expanded: !!props.expanded
  });
  React.useEffect(() => {
    setState({ expanded: !!props.expanded });
  }, [props.expanded]);

  return (
    <>
      {props.hat &&
        props.hat.length > 0 &&
        props.hat[0] &&
        props.hat[0].message && (
          <div style={{ marginTop: '40px' }}>
            <Hat hat={props.hat} />
          </div>
        )}
      <div
        className={`accordion ${theme} ${props.flipBg ? 'flipBg' : ''} ${
          state.expanded ? 'expand' : ''
        }${props.isDivider ? ' transparent' : ''}`}
        aria-label={getInnerText(props.title)}
      >
        <div
          className="accordion-title"
          role="button"
          onClick={() => {
            setState({ expanded: !state.expanded });
            if (props.onExpand !== undefined) {
              props.onExpand(!state.expanded);
            }
          }}
          onKeyDown={(e: any) => {
            if (e.keyCode === 13 || e.keyCode === 32) {
              e.preventDefault();
              setState({ ...state, expanded: !state.expanded });
            }
          }}
          tabIndex={0}
          aria-label={getInnerText(props.title)}
          aria-controls={`${props.id}-panel`}
          aria-expanded={state.expanded}
          onMouseDown={e => {
            e.preventDefault();
          }}
        >
          <div id={`${props.id}-accord`} className="text">
            {props.title}
          </div>
          {props.isDivider && <div className="dividerLine">&nbsp;</div>}
          <div className="icon"></div>
        </div>
        <div
          role="region"
          aria-labelledby={`${props.id}-a`}
          id={`${props.id}-panel`}
          className={`expanded-content ${theme} ${
            state.expanded ? '' : ' collapsed-content'
          }`}
        >
          {lazyLoad ? state.expanded && props.children : props.children}
        </div>
      </div>
    </>
  );
}
